import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// This component redirects to the new TeeSheetView
const BookingPage = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();

  // Redirect to the new tee sheet view
  useEffect(() => {
    navigate(`/tee-sheet/${eventId}`, { replace: true });
  }, [eventId, navigate]);

  // Show loading while redirecting
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Loading booking page...</p>
      </div>
    </div>
  );
};

export default BookingPage;